import { Injectable } from '@angular/core';
import { Observable, of, map, catchError } from 'rxjs';
import { GoogleSheetsBaseService } from './google-sheets-base.service';

@Injectable({
  providedIn: 'root'
})
export class SsoSheetsService extends GoogleSheetsBaseService {

  /**
   * Fetches all SSO users from the Google Sheet.
   * @returns An Observable of the API response, or null on error.
   */
  ssoGetAllUsers(): Observable<any> {
    const tabName = 'ssousersallowed';
    const startCell = 'A2';
    const endCell = 'E300';
    return this.getSheetData(tabName, startCell, endCell);
  }

  /**
   * Fetches a list of allowed SSO user IDs from the Google Sheet.
   * @returns An Observable of the user IDs array, or an empty array on error.
   */
  ssoUserIdAllowList(): Observable<string[]> {
    const tabName = 'ssousersallowed';
    const startCell = 'A2';
    const endCell = 'A300';

    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(response => {
        if (response && response.length > 0) {
          return response[0];
        } else {
          console.error('SsoSheetsService | ssoUserIdAllowList | no SSO allow users list');
          return [];
        }
      }),
      catchError(error => {
        console.error('Error fetching SSO user ID allow list:', error);
        return of([]);
      })
    );
  }
}